import {
  Component,
  ChangeDetectionStrategy,
  Input,
  OnChanges,
} from '@angular/core';
import { fadeIn } from '@animations/fade-in';
import { InboundFlightStore } from '../inbound-flight.store';
import { Observable } from 'rxjs';
import { CrewListView } from '@flight-details/crew/models/view/crew-list.view';
import { RequestState } from '@shared/models/request-state';
import { LegView } from '@sequence/models/view/leg.view';
import { InboundFlightView } from '../models/inbound-flight.view';

@Component({
  selector: 'app-inbound-flight-card',
  templateUrl: './inbound-flight-card.component.html',
  styleUrls: ['./inbound-flight-card.component.scss'],
  standalone: false,
  animations: [fadeIn],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InboundFlightCardComponent implements OnChanges {
  @Input() flightState?: LegView;

  inboundCrew$?: Observable<RequestState<CrewListView>>;
  inboundFlightStatus$?: Observable<RequestState<InboundFlightView>>;

  constructor(private inboundFlightStore: InboundFlightStore) {}

  ngOnChanges(): void {
    this.loadInboundFlight();
  }

  getFlightAwareLink(flightNumber: string): string {
    if (flightNumber) {
      return `https://flightaware.com/live/flight/AAL${flightNumber}`;
    }

    return '';
  }

  onExpand() {
    this.loadInboundFlight();
  }

  refresh() {
    this.loadInboundFlight(true);
  }

  private loadInboundFlight(isRefresh = false): void {
    if (this.flightState) {
      this.inboundCrew$ = this.inboundFlightStore.getInboundCrewList(
        this.flightState,
        isRefresh,
      );
      this.inboundFlightStatus$ =
        this.inboundFlightStore.getInboundFlightStatus(
          this.flightState,
          isRefresh,
        );
    }
  }
}
